import { ArgumentError } from "../errors";

export namespace ObjectDiff
{
    export function getDiff<T>(first: T, second: T): string[]
    {
        const discriminator = new ObjectDiscriminator();
        return discriminator.getDiff(first, second);
    }

    class ObjectDiscriminator
    {
        getDiff<T>(first: T, second: T): string[]
        {
            this.compare(first, second, "");
            return this.diffs;
        }

        private compare(val1: any, val2: any, path: string)
        {
            // Throw on circular reference
            if (this.seen.has(val1) || this.seen.has(val2))
                throw new circularError.type(circularError.message);

            // Add to this.seen to track circular references
            if (typeof val1 === "object" && val1 !== null) this.seen.add(val1);
            if (typeof val2 === "object" && val2 !== null) this.seen.add(val2);

            // Push if objects are of different types
            if (typeof val1 !== typeof val2)
            {
                this.diffs.push(path);
                return;
            }

            // If both objects are arrays:
            if (Array.isArray(val1) && Array.isArray(val2))
            {
                // Push if they are of different length
                if (val1.length !== val2.length)
                {
                    this.diffs.push(path);
                    return;
                }

                // Otherwise recurse on each item
                val1.forEach((item, index) =>
                {
                    this.compare(item, val2[index], `${path}[${index}]`);
                });

                return;
            }

            if (typeof val1 === "object" && val1 !== null && val2 !== null)
            {
                const keys = new Set([
                    ...Object.keys(val1),
                    ...Object.keys(val2)
                ]);

                keys.forEach((key) =>
                {
                    this.compare(
                        val1[key],
                        val2[key],
                        path ? `${path}.${key}` : key
                    );
                });

                return;
            }

            if (val1 !== val2)
                this.diffs.push(path);
        }

        private seen = new WeakSet();
        private diffs: string[] = [];
    }
}

export const circularError =
{
    type: ArgumentError,
    message: "getDiff() encountered a circular reference"
};
